import EventBus from '@/components/mixins/event-bus-mixin'
import CommonOptionsMixin from '@/components/mixins/common-options-mixin'
import UnsavedDataMixin from '@/components/mixins/unsaved-data-mixin'

// @qa-tests: ChangeLanguage
export default {
  name: 'languageSelector',
  inject: [
    '$utils',
    '$dataStore'
  ],
  components: {
  },
  props: {},
  watch: {},
  data () {
    return {
      isVisible: false,
      languages: this.languageCommonOptions(),
      selectedLanguage: this.$dataStore.getLanguage()
    }
  },
  mixins: [CommonOptionsMixin, UnsavedDataMixin],
  methods: {
    handleLanguageClick (language) {
      this.selectedLanguage = language
    },
    handleCloseDialog () {
      this.isVisible = false
      this.selectedLanguage = this.$dataStore.getLanguage()
      EventBus.$emit('HIDE_LANGUAGE_SELECTOR', {})
    },
    handleSaveChanges () {
      this.checkUnsavedData({
        nextAction: () => {
          this.$dataStore.setLanguage(this.selectedLanguage.code, this.selectedLanguage.name, this.selectedLanguage.icon, true)
          window.location.reload(true)
        }
      })
    }
  },
  mounted () {
    EventBus.$on('SHOW_LANGUAGE_SELECTOR', (payload) => {
      this.selectedLanguage = this.$dataStore.getLanguage()
      this.isVisible = true
    })
  }
}
